import { createApp } from '@app/adapters/create-app'
import type { App as Application } from 'vue'

import InsightsSidepaneToggle from '@app/insights/components/insights-sidepane-toggle.vue'

window.onDomLoad(function ($dom) {
  const doc = $dom[0]
  const element = doc.querySelector(
    "[data-behaviour='insights/sidepane-toggle']"
  ) as HTMLElement

  if (!element) return

  const app: Application = createApp(InsightsSidepaneToggle)
  app.mount(element)
})
